export default __webpack_public_path__ + "static/media/carmel.463d0cbc.svg";